// Utils
import debounce from 'lodash/debounce';
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

import choozy from 'utils/choozy';
import { dispatch } from 'utils/theme';

export default component((node) => {
  const { toggle, inner } = choozy(node);
  const { pdpTracking } = node.dataset;

  const group = node.closest('[data-accordion-group]');

  const toggleAccordion = () => {
    if (node.hasAttribute('data-accordion-interchangeable')) {
      const innerHeight = inner.offsetHeight;
      const innerWidth = inner.offsetWidth;
      node.style.setProperty('--inner-height', `${innerHeight}px`);
      node.style.setProperty('--inner-width', `${innerWidth}px`);

      const isOpen = node.classList.contains('open');
      const allAccordions = document.querySelectorAll('[data-accordion-interchangeable]');
      allAccordions.forEach((accordion) => {
        if (accordion !== node) {
          accordion.classList.remove('open');
          accordion.style.removeProperty('--inner-height');
        }
      });
      if (isOpen) {
        node.classList.remove('open');
        node.style.removeProperty('--inner-height');
      } else {
        node.classList.add('open');
      }
    } else {
      if (group) {
        const openAccordion = group.querySelector('.group\\/accordion.open');
        if (openAccordion && openAccordion !== node)
          openAccordion.dispatchEvent(new Event('toggle'));
      }

      node.classList.toggle('open');
      inner.toggleAttribute('inert', !node.classList.contains('open'));
      toggle.setAttribute('aria-expanded', node.classList.contains('open'));
    }

    if (theme.pageType === 'collection') {
      const filterInput = node.querySelector('input');

      if (!filterInput) return;

      const filterName = filterInput.getAttribute('name').split('.').at(-1);

      dispatch('filter-accordion-toggle', {
        type: filterName,
        action: node.classList.contains('open') ? 'expand' : 'collapse',
      })
    }

    if (pdpTracking)
      dispatch(
        node.classList.contains('open') ? 'pdp-click-accordion-exp' : 'pdp-click-accordion-col',
        {
          title: toggle.innerText,
        },
      );
  };

  toggle.addEventListener('click', toggleAccordion);
  node.addEventListener('toggle', toggleAccordion);

  const observer = new ResizeObserver(
    debounce(([entry]) => {
      setCSSProperty(node, '--inner-height', `${entry.borderBoxSize[0].blockSize}px`);
    }, 200),
  );

  observer.observe(inner);
});
